import React, { useRef } from 'react';
import cn from 'classnames';

import { makeFavoriteHeartButton, makeHandleHeartButtonClick } from 'helpers/HeartUtils';

import css from 'styles/components/common/hearts.scss';

const Hearts = ({ heartsData = {}, styleId, productId }) => {
  const heartRef = useRef();
  const { showFavoriteHeart, hearts = [], heartsList, isDisplayCount, hydraHeartsStars } = heartsData;
  if (!hearts) {
    return null;
  }

  const handleHeartClick = () => {
    const { onHeartClick, hearts, showFavoriteHeart } = heartsData;
    return makeHandleHeartButtonClick({
      hearts,
      onHeartClick,
      productId,
      showFavoriteHeart,
      heartRef,
      style: { styleId }
    });
  };

  return (
    <div className={cn(css.heartContainer, { [css.noCountContainer]: !isDisplayCount }, { [css.searchHeartContainer]: hydraHeartsStars === 3 }) }>
      {makeFavoriteHeartButton({
        cssHeartContainer: cn(css.heart, { [css.noCountHeart]: !isDisplayCount }, { [css.searchHeart]: hydraHeartsStars === 3 }),
        cssHeartActive: css.heartActive,
        extraRecoStyle: null,
        handleHeartClick,
        hearts,
        heartsList,
        productId,
        showFavoriteHeart,
        compactCount: true,
        style: { styleId },
        isDisplayCount,
        testId: 'heartButton'
      })}
    </div>
  );
};

export default Hearts;
